// @ts-nocheck Code venant de UI Kitten directement
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import React from 'react';
import {
  Animated,
  Easing,
  LayoutChangeEvent,
  Platform, View,
  ViewProps,
  ViewStyle,
} from 'react-native';
import { RTLService } from '@ui-kitten/components/devsupport';
import { LinearGradient } from 'expo-linear-gradient';
import { withStyles } from '@ui-kitten/components';

export interface TabIndicatorProps extends ViewProps {
  positions: number;
  selectedPosition?: number;
  eva: EvaProp
}

export type TabIndicatorElement = React.ReactElement<TabIndicatorProps>;

export class TabIndicatorBase extends React.Component<TabIndicatorProps> {
  static defaultProps: Partial<TabIndicatorProps> = {
    selectedPosition: 0,
  };

  private indicatorWidth: number;

  private opacity: Animated.Value = new Animated.Value(0);

  private contentOffset: Animated.Value = new Animated.Value(0);

  public componentDidMount() {
    this.opacity.addListener(this.onContentOffsetAnimationStateChanged);
  }

  public shouldComponentUpdate(nextProps: TabIndicatorProps): boolean {
    return this.props.selectedPosition !== nextProps.selectedPosition;
  }

  public componentDidUpdate() {
    const { selectedPosition: index } = this.props;

    this.scrollToIndex({
      index,
      animated: true,
    });
  }

  public componentWillUnmount() {
    this.opacity.removeAllListeners();
  }

  /**
     * scrolls indicator to passed index
     *
     * @param params (object) - {
     *  index: number,
     *  animated: boolean | undefined
     * }
     */
  public scrollToIndex(params: { index: number, animated?: boolean }) {
    const { index, ...rest } = params;
    const offset: number = this.indicatorWidth * index;

    this.scrollToOffset({ offset, ...rest });
  }

  /**
     * scrolls indicator to passed offset
     *
     * @param params (object) - {
     *  offset: number,
     *  animated: boolean | undefined
     * }
     */
  public scrollToOffset(params: { offset: number, animated?: boolean }) {
    this.opacity.setValue(0);
    this.contentOffset.setValue(params.offset);
    this.createOpacityAnimation(params).start(this.onContentOffsetAnimationStateEnd);
  }

  private onContentOffsetAnimationStateChanged = (state: { value: number }) => {
    // no-op
  };

  private onContentOffsetAnimationStateEnd = (result: { finished: boolean }) => {
    // no-op
  };

  private createOpacityAnimation = (params: { offset: number, animated?: boolean }): Animated.CompositeAnimation => Animated.timing(this.opacity, {
    toValue: 1,
    duration: 500,
    easing: Easing.ease,
    useNativeDriver: Platform.OS !== 'web',
  });

  private onLayout = (event: LayoutChangeEvent) => {
    this.indicatorWidth = event.nativeEvent.layout.width;

    this.scrollToOffset({
      offset: this.indicatorWidth * this.props.selectedPosition,
      animated: false,
    });
  };

  private getComponentStyle = (): ViewStyle => {
    const widthPercent: number = 100 / this.props.positions;

    return {
      width: `${widthPercent}%`,
      opacity: this.opacity,
      transform: [{ translateX: this.contentOffset }],
    };
  };

  public render(): React.ReactElement<ViewProps> {
    const { style, ...viewProps } = this.props;
    const evaStyle: ViewStyle = this.getComponentStyle();

    return (
      <Animated.View
        {...viewProps}
        style={[style, evaStyle, { backgroundColor: 'transparent' }]}
        onLayout={this.onLayout}
      >
        <View style={{
          position: 'absolute',
          left: '50%',
          marginLeft: -35,
          right: 0,
          top: 0,
          bottom: 0,
          width: 70,
          borderRadius: 0,
          backgroundColor: this.props.eva.theme['color-primary-500'],
        }}
        />
      </Animated.View>
    );
  }
}

export const TabIndicator = withStyles(TabIndicatorBase);
